import { Box } from '@mui/material'
import { Error } from '@mui/icons-material'
import { FormattedMessage } from 'react-intl'
import { makeStyles } from 'tss-react/mui'

type ProductNotSoldProps = {
  productNumber: string
}

export const useStyles = makeStyles()((theme) => ({
  productNumber: {
    fontWeight: theme.typography.fontWeightBold,
  },
}))

export const ProductNotSold: React.FC<ProductNotSoldProps> = ({
  productNumber,
}) => {
  const { classes } = useStyles()

  return (
    <Box display="flex" data-testid="product-not-sold-container">
      <Box mr={2}>
        <Error color="error" data-testid="error-icon" />
      </Box>
      <Box>
        <FormattedMessage
          id="PRODUCT_NOT_SOLD_IN_COUNTRY"
          defaultMessage="Product {productNumber} is not currently sold in your country."
          values={{
            productNumber: (
              <span className={classes.productNumber}>{productNumber}</span>
            ),
          }}
        />
      </Box>
    </Box>
  )
}

export default ProductNotSold
